// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .date-is-due[data-v-63840b90]{border-left:5px solid orange;background:#fff8f1}.hrsata-jobs .has-ended[data-v-63840b90]{border-left:5px solid red;background:#ffeded}", ""]);
// Exports
module.exports = exports;
